export default __webpack_public_path__ + "static/media/contact.0aa28511.svg";